import React, { useState } from 'react';
import keycode from 'keycode';


export function PreviewCustomSizeInput (props) {
  const [prevValue, setPrevValue] = useState(0);
  const [value, setValue] = useState(0);

  function dispatchChange () {
    setPrevValue(value);
    props.onChange(value);
  }

  function handleKeyDown (e) {
    const key = keycode(e);
    if (key === 'enter') {
      e.preventDefault();
      dispatchChange();
    }
  }

  if (prevValue !== props.value) {
    setPrevValue(props.value);
    setValue(props.value);
  }

  return (
    <input
      type="number" title={props.title}
      className="inp_type1"
      value={value} onChange={e => setValue(e.target.value)}
      onKeyDown={handleKeyDown} onBlur={dispatchChange}
    />
  );
}
